import { CommonScreentime, CommonScreentimeLimit } from '@codidae/common-types';
import HTTPClient from 'utils/HTTPClient';

export function getScreentimeForPeriod(
  childId: number,
  start: Date,
  end: Date,
): Promise<{ date: Date; screentimes: CommonScreentime[] }[]> {
  return HTTPClient.get('/screentime', {
    params: {
      childId,
      start,
      end,
    },
  }).then((data) => data.data);
}

export function lockEveryApplication(childId: number): Promise<void> {
  return HTTPClient.post('/screentime-limit/lock/all', undefined, {
    params: {
      childId,
    },
  }).then((data) => data.data);
}

export function unlockEveryApplication(childId: number): Promise<void> {
  return HTTPClient.post('/screentime-limit/unlock/all', undefined, {
    params: {
      childId,
    },
  }).then((data) => data.data);
}

export function lockSpecificApplications({
  childId,
  applicationIds,
}: {
  childId: number;
  applicationIds: number[];
}): Promise<void> {
  return HTTPClient.post(
    '/screentime-limit/lock',
    { applicationIds },
    {
      params: {
        childId,
      },
    },
  ).then((data) => data.data);
}

export function unlockSpecificApplications({
  childId,
  applicationIds,
}: {
  childId: number;
  applicationIds: number[];
}): Promise<void> {
  return HTTPClient.post(
    '/screentime-limit/unlock',
    { applicationIds },
    {
      params: {
        childId,
      },
    },
  ).then((data) => data.data);
}

export function getScreentimeLimits(childId: number): Promise<CommonScreentimeLimit[]> {
  return HTTPClient.get('/screentime-limit', {
    params: {
      childId,
    },
  }).then((data) => data.data);
}

export function createScreentimeLimit({
  childId,
  duration,
  applicationId,
  groupId,
  priority,
}: {
  childId: number;
  duration: number;
  applicationId?: number;
  groupId?: number;
  priority: number;
}): Promise<CommonScreentimeLimit> {
  return HTTPClient.post('/screentime-limit', {
    childId,
    duration,
    applicationId,
    groupId,
    priority,
  }).then((data) => data.data);
}

export function deleteScreentimeLimit({ childId, id }: { childId: number; id: number }): Promise<void> {
  return HTTPClient.delete(`/screentime-limit/${id}`, {
    params: {
      childId,
    },
  }).then((data) => data.data);
}

export function updateScreentimeLimit({
  childId,
  id,
  duration,
  priority,
}: {
  childId: number;
  id: number;
  duration?: number;
  priority?: number;
}): Promise<void> {
  return HTTPClient.post(`/screentime-limit/${id}`, {
    duration,
    priority,
    childId,
  }).then((data) => data.data);
}
